import { combineReducers } from 'redux';

import { maintenanceStandardAssetsReducer } from './assets/Assets.reducers';
import { auditsReducer } from './audits/store/audits.reducer';
import { ticketsFiltersReducer } from './common/components/topBar/store/ticketsFilters.reducer';
import { ticketsReducer } from './pages/ticketsPage/store/tickets.reducer';
import { ticketsSearchReducer } from './pages/ticketsSearchPage/store/ticketsSearch.reducer';
import { maintenanceStandardReportsReducer } from './reports/store/maintenance-standard-reports.reducer';
import { maintenanceStandardSchedulerReducer } from './scheduler/ShedulerReducer';
import { maintenanceStandardTicketsReducer } from './tickets/reducer';
import { ticketDetailsReducer } from './tickets/store/ticketDetails.reducer';

export const maintenanceStandardReducer = combineReducers({
    tickets: maintenanceStandardTicketsReducer,
    ticketsDetails: ticketDetailsReducer,
    reports: maintenanceStandardReportsReducer,
    assets: maintenanceStandardAssetsReducer,
    scheduler: maintenanceStandardSchedulerReducer,
    ticketsPage: ticketsReducer,
    ticketsSearchPage: ticketsSearchReducer,
    ticketsFilters: ticketsFiltersReducer,
    audits: auditsReducer,
});
